export default "__VITE_ASSET__Bp3xNN6j__"